<template>
  <van-popup v-model="popShow" :close-on-click-overlay="false" position="bottom">
    <div
      ref="popupRef"
      class="set_payment_code_popup"
      :class="{ pwd_sheet: curStep === 2 || curStep === 3 }"
      :style="{
        textAlign: $store.state.isMirroring ? 'right' : 'left'
      }"
    >
      <div class="sub_container" v-show="curStep === 1">
        <div v-show="showSlideVerification" id="slideVerification" class="slide_verification"></div>
        <div v-show="popShow && !showSlideVerification" class="verify_step">
          <div class="verify_main">
            <div class="verify_header">
              <div class="verify_title_row">
                <div class="title">{{ title }}</div>
                <img
                  :class="$store.state.isMirroring && 'mirror'"
                  class="close"
                  src="@/assets/paymentCode/close.svg"
                  alt=""
                  @click="closePopup"
                />
              </div>
              <div class="account">
                {{ verifyType === 'EMAIL' ? $store.state.userInfo.email : '+' + $store.state.userInfo.phone }}
              </div>
            </div>
            <CommonInput
              v-model="smsCode"
              type="tel"
              inputmode="numeric"
              :placeholder="$t('accountSecurity.enterVerificationCode')"
              theme="white"
              :max-length="VALID_CODE_LENGTH"
              auto-focus
            >
              <div class="send_span" :class="msgValidating && 'disabled'" @touchend.stop.prevent="resend">
                {{ !msgValidating ? (firstSendMsg ? $t('common.send') : $t('common.resend')) : count + 's' }}
              </div>
            </CommonInput>
          </div>
          <div class="verify_footer">
            <CommonBtn class="next_btn" :text="$t('common.next')" :disabled="!smsCode" :on-click="nextStep" />
            <div
              v-show="verifyType !== 'EMAIL' && emailBtnShow"
              class="switch_verify_type"
              @click="() => changeVerifyType('EMAIL')"
            >
              {{ $t('loginAndRegister.verifyEmail') }}
            </div>
            <div
              v-show="verifyType !== 'PHONE' && phoneBtnShow"
              class="switch_verify_type"
              @click="() => changeVerifyType('PHONE')"
            >
              {{ $t('loginAndRegister.verifyPhone') }}
            </div>
          </div>
        </div>
      </div>
      <div class="sub_container pwd_step" v-if="curStep === 2 || curStep === 3">
        <div class="verify_title_row">
          <div class="title">
            {{ curStep === 2 ? $t('paymentCode.payPwdNote') : $t('redesign.reenterPayPwdPlaceholder') }}
          </div>
          <img
            :class="$store.state.isMirroring && 'mirror'"
            class="close"
            src="@/assets/paymentCode/close.svg"
            alt=""
            @click="closePopup"
          />
        </div>
        <div class="pwd_input_block">
          <div class="pwd_boxes" @click="showKeyboard = true">
            <div class="pwd_box" v-for="n in 6" :key="n">
              <span v-if="currentPwd.length >= n">*</span>
            </div>
          </div>
          <div class="pwd_hint" :class="inconsistentError && 'error'">
            {{ inconsistentError || $t('paymentCode.payPwdFormatToast') }}
          </div>
        </div>
        <van-number-keyboard
          :show="showKeyboard"
          :hide-on-click-outside="false"
          get-container="#app"
          z-index="3000"
          @input="onInput"
          @delete="onDelete"
        />
      </div>
    </div>
  </van-popup>
</template>

<script>
import CommonInput from '@/components/CommonInput'
import CommonBtn from '@/components/CommonBtn'
import md5 from 'js-md5'
import { Toast } from 'vant'
import { getUserInfo } from '@/service'
import throttle from 'lodash/throttle'
import { isInWebView } from '@/utils'
import { VALID_CODE_LENGTH } from '@/utils/constants'
import interceptSystemBack from '@/mixins/interceptSystemBack'

export default {
  name: 'PaymentCodeSetPopup',
  mixins: [interceptSystemBack],
  components: {
    CommonInput,
    CommonBtn
  },
  props: {
    value: {
      type: Boolean,
      required: true
    },
    hasOldPaymentCode: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      VALID_CODE_LENGTH,
      firstLoad: true,
      popShow: this.value,
      curStep: 1, // 1: 验证阶段 2: 输入 3: 再次输入
      verifyType: 'EMAIL', // 验证方式
      showSlideVerification: false,
      smsCode: '',
      firstSendMsg: true,
      interval: undefined,
      msgValidating: false,
      count: 59,
      paymentCode: '',
      reenterPaymentCode: '',
      areaCode: '',
      showKeyboard: true,
      inconsistentError: '',
      toWhatsapp: false
    }
  },
  computed: {
    emailBtnShow() {
      return !!this.$store.state.userInfo.email
    },
    phoneBtnShow() {
      return !!this.$store.state.userInfo.phone
    },
    title() {
      if (!this.hasOldPaymentCode) {
        return this.$t('paymentCode.verifyToSetPayPwd')
      }
      return this.verifyType === 'EMAIL'
        ? this.$t('redesign.sendToEmail')
        : this.toWhatsapp
          ? this.$t('redesign.sendToWhatsapp')
          : this.$t('redesign.sendToPhone')
    },
    currentPwd() {
      return this.curStep === 3 ? this.reenterPaymentCode : this.paymentCode
    }
  },
  watch: {
    value(val) {
      this.popShow = val
      if (val) {
        if (this.firstLoad) {
          this.firstLoad = false
          this.initSlideVerification()
        }
        this.curStep = 1
        this.smsCode = ''
        this.paymentCode = ''
        this.reenterPaymentCode = ''
        this.inconsistentError = ''
        this.showKeyboard = false
        this.showSlideVerification = false
        this.msgValidating = false
        this.count = 59
        this.firstSendMsg = true
        this.interval && clearInterval(this.interval)
        if (this.$store.state.userInfo.email) {
          this.verifyType = 'EMAIL'
          this.sendSmsCode()
        } else {
          this.verifyType = 'PHONE'
          this.showSlideVerification = true
        }
        if (isInWebView()) {
          document.addEventListener('touchstart', this.checkInputFocus)
          this.checkInputFocus()
        }
        this.startBackTrap()
      } else {
        if (isInWebView()) {
          document.removeEventListener('touchstart', this.checkInputFocus)
        }
        this.clearBackTrap()
      }
    },
    popShow(val) {
      this.$emit('input', val)
    },
    smsCode(val) {
      if (val.length === this.VALID_CODE_LENGTH) {
        this.nextStep()
      }
    }
  },
  mounted() {
    this.getAreaCodes()
  },
  methods: {
    getUserInfo,
    checkInputFocus() {
      setTimeout(() => {
        if (document.activeElement.tagName === 'INPUT') {
          this.$refs.popupRef.style.paddingBottom = '35vh'
        } else {
          this.$refs.popupRef.style.paddingBottom = '0.24rem'
        }
      }, 200)
    },
    initSlideVerification() {
      const $this = this
      initSMCaptcha(
        {
          organization: '90I5YRBCdvRoD8mXmETq',
          domains: ['captcha-xjp.fengkongcloud.cn'], // 新加坡
          product: 'embed', // 展现形式
          appendTo: 'slideVerification', // 指定 DOM 节点
          mode: 'slide', // 验证码模式
          lang: 'en',
          width: 295,
          style: {
            slideBar: {
              color: '#3FBB70',
              successColor: '#3FBB70',
              border: 'none',
              process: {
                background: '#3FBB7033',
                failBackground: '#ff4c6233'
              },
              button: {
                boxShadow: 'none',
                background: '#3FBB70',
                failBackground: '#ff4c62'
              }
            }
          }
        },
        (SMCaptcha) => {
          SMCaptcha.onSuccess(function (data) {
            if (data.pass) {
              $this.showSlideVerification = false
              SMCaptcha.reset()
              $this.sendSmsCode(data.rid)
            }
          })
        }
      )
    },
    changeVerifyType(type) {
      this.verifyType = type
      if (type === 'PHONE') {
        this.showSlideVerification = true
        clearInterval(this.interval)
        this.msgValidating = false
        this.count = 59
        this.smsCode = ''
      } else if (type === 'EMAIL') {
        this.showSlideVerification = false
        clearInterval(this.interval)
        this.msgValidating = false
        this.count = 59
        this.sendSmsCode()
        this.smsCode = ''
      }
    },
    async getAreaCodes() {
      const $this = this
      const countryNo = this.$store.state.userInfo.countryNo
      await this.$http
        .get(window.serverPath + '/api/country/getAreaCodes', { cache: true })
        .then(function (res) {
          if (res.data && res.data.code === '200' && res.data.data) {
            res.data.data.forEach((each) => {
              if (each.countryNo === countryNo) {
                $this.areaCode = each.areaCode
              }
            })
          }
        })
        .catch((_err) => {
          console.log('err')
        })
    },
    resend() {
      if (this.msgValidating) {
        return
      }
      this.smsCode = ''
      if (this.verifyType === 'EMAIL') {
        this.sendSmsCode()
      } else {
        this.showSlideVerification = true
      }
    },
    async sendSmsCode(rid = '') {
      if (this.msgValidating) {
        return
      }
      if (!this.areaCode) {
        await this.getAreaCodes()
      }
      let isEmail = this.verifyType === 'EMAIL'
      const $this = this
      const phone = this.$store.state.userInfo.phone
      const email = this.$store.state.userInfo.email
      let url = window.serverPath + (isEmail ? '/api/auth/getNewEmailCode' : '/api/auth/getNewSmsCode')
      if (this.hasOldPaymentCode) {
        url += '/CHANGE_PAY_PASSWORD'
      } else {
        url += '/SET_PAY_PASSWORD'
      }
      let params = isEmail
        ? {
            email: email
          }
        : {
            phone: phone,
            areaCode: this.areaCode,
            rid: rid
          }
      if (phone || email) {
        this.$http
          .post(url, params)
          .then((res) => {
            if (res.data.code === '200') {
              $this.msgValidating = true
              $this.firstSendMsg = false
              $this.toWhatsapp = res.data.data === 'Whatsapp'
              $this.interval = window.setInterval(() => {
                $this.count -= 1
                if ($this.count <= 0) {
                  clearInterval($this.interval)
                  $this.msgValidating = false
                  $this.count = 59
                }
              }, 1000)
            } else if (res.data.code === '60001') {
              Toast({
                message: this.$t('loginAndRegister.userExistToast')
              })
            } else {
              Toast({
                message: res.data.message
              })
            }
          })
          .catch((_err) => {
            console.log('异常')
            $this.msgValidating = false
            $this.count = 59
          })
      }
    },
    nextStep: throttle(
      function () {
        if (!this.smsCode) {
          Toast({ message: this.$t('loginAndRegister.verificationCodeEmptyToast') })
          return
        }
        const params = {}
        if (this.verifyType === 'EMAIL') {
          params.email = this.$store.state.userInfo.email
        } else {
          params.phone = this.$store.state.userInfo.phone
        }
        params.validCode = this.smsCode
        let url = this.verifyType === 'EMAIL' ? '/api/auth/checkEmailCode' : '/api/auth/checkSmsCode'
        if (this.hasOldPaymentCode) {
          url += '/CHANGE_PAY_PASSWORD'
        } else {
          url += '/SET_PAY_PASSWORD'
        }
        this.$http
          .post(window.serverPath + url, params)
          .then((res) => {
            if (res.data.code === '200') {
              this.curStep = 2
              this.showKeyboard = true
              this.$store.commit('setSecurityToken', res.data.data.securityToken)
            } else {
              Toast({
                message: this.$t('accountSecurity.wrongCodeToast')
              })
            }
          })
          .catch((_err) => {
            console.log('异常?', _err)
          })
      },
      5000,
      { trailing: false }
    ),
    onInput(key) {
      if (this.curStep === 2) {
        this.paymentCode = (this.paymentCode + key).slice(0, 6)
        this.inconsistentError = ''
        if (this.paymentCode.length === 6) {
          this.curStep = 3
        }
      } else if (this.curStep === 3) {
        this.reenterPaymentCode = (this.reenterPaymentCode + key).slice(0, 6)
        if (this.reenterPaymentCode.length === 6) {
          this.setPassword()
        }
      }
    },
    onDelete() {
      if (this.curStep === 2) {
        this.paymentCode = this.paymentCode.slice(0, this.paymentCode.length - 1)
      } else if (this.curStep === 3) {
        if (this.reenterPaymentCode.length === 0) {
          // 清空后再点击删除按钮回到上一步
          this.curStep = 2
        } else {
          this.reenterPaymentCode = this.reenterPaymentCode.slice(0, this.reenterPaymentCode.length - 1)
        }
      }
    },
    closePopup(fromPopstate) {
      this.showKeyboard = false
      this.popShow = false
      if (fromPopstate !== true) {
        this.stopBackTrap()
      }
    },
    onSystemBack() {
      const active = document.activeElement
      if (active && active.tagName === 'INPUT') {
        active.blur()
        return true
      }
      if (this.showKeyboard) {
        this.showKeyboard = false
        return true
      }
      if (this.popShow) {
        this.closePopup(true)
      }
      return false
    },
    setPassword() {
      const paymentCode = this.paymentCode
      const enterAgain = this.reenterPaymentCode
      if (paymentCode && enterAgain && paymentCode.substr(0, 6) === enterAgain.substr(0, 6)) {
        const params = {}
        params.password = md5(paymentCode.substr(0, 6))
        params.securityToken = this.$store.state.securityToken
        params.userId = this.$store.state.userInfo.userId
        this.$http
          .post(
            window.serverPath + (this.hasOldPaymentCode ? '/api/user/editPayPassword' : '/api/user/setPayPassword'),
            params
          )
          .then((res) => {
            if (res.data.code === '200') {
              Toast.success({
                message: this.$t('paymentCode.successToast'),
                onClose: this.closePopup()
              })
              this.$store.commit('delSecurityToken')
              this.getUserInfo()
              this.$emit('success')
            } else if (res.data.code === '100013') {
              this.curStep = 1
              this.smsCode = ''
              this.reenterPaymentCode = ''
              this.paymentCode = ''
              this.inconsistentError = ''
              Toast(res.data.message)
            } else {
              this.curStep = 2
              this.reenterPaymentCode = ''
              this.paymentCode = ''
              this.inconsistentError = this.$t('basicLevel.failToast')
            }
          })
          .catch((_err) => {
            console.log('异常')
          })
      } else {
        this.curStep = 2
        this.reenterPaymentCode = ''
        this.paymentCode = ''
        this.inconsistentError = this.$t('paymentCode.inconsistentPasswordToast')
      }
    }
  }
}
</script>

<style scoped>
.set_payment_code_popup {
  padding: 0.24rem 0.2rem;
  background: #fff;
  border-radius: 0.16rem 0.16rem 0 0;
  position: relative;
}

.pwd_sheet {
  min-height: 4.8rem;
}

.sub_container {
  width: 100%;
  height: 100%;
}

.verify_step {
  display: flex;
  flex-direction: column;
  gap: 0.48rem;
}

.verify_main {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  width: 100%;
}

.verify_header {
  display: flex;
  flex-direction: column;
  gap: 0.04rem;
  width: 100%;
}

.verify_title_row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.12rem;
  width: 100%;
}

.slide_verification {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.title {
  flex: 1;
  min-width: 0;
  color: #2f2f2f;
  font-family: 'PingFang SC';
  font-size: 0.2rem;
  font-style: normal;
  font-weight: 600;
  line-height: 0.28rem;
  word-break: break-word;
}

.account {
  color: #3fbb70;
  font-family: 'PingFang SC';
  font-size: 0.14rem;
  font-style: normal;
  font-weight: 600;
  line-height: 0.22rem;
  direction: ltr;
  word-break: break-all;
}

.send_span {
  color: #3fbb70;
  font-size: 0.14rem;
  font-family: 'PingFang SC';
  font-style: normal;
  font-weight: 400;
  line-height: 0.22rem;
  white-space: nowrap;
}

.send_span.disabled {
  color: #828282;
}

.verify_footer {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.12rem;
}

.next_btn {
  margin: 0;
  font-size: 0.16rem !important;
}

.switch_verify_type {
  width: 100%;
  text-align: center;
  color: #3fbb70;
  font-family: 'PingFang SC';
  font-size: 0.14rem;
  font-style: normal;
  font-weight: 600;
  line-height: 0.22rem;
}

.close {
  width: 0.24rem;
  height: 0.24rem;
  flex-shrink: 0;
}

.pwd_step {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  width: 100%;
}

.pwd_input_block {
  display: flex;
  flex-direction: column;
  gap: 0.12rem;
  width: 100%;
}

.pwd_boxes {
  display: flex;
  gap: 0.16rem;
  width: 100%;
}

.pwd_box {
  flex: 1;
  min-width: 0;
  height: 0.6rem;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.1rem;
  box-sizing: border-box;
  border-radius: 0.12rem;
  background: rgba(63, 187, 112, 0.15);
  color: #3fbb70;
  font-family: 'PingFang SC';
  font-size: 0.36rem;
  font-weight: 600;
  line-height: 0.44rem;
}

.pwd_box span {
  white-space: nowrap;
}

.pwd_hint {
  width: 100%;
  color: #3fbb70;
  text-align: center;
  font-family: 'PingFang SC';
  font-size: 0.12rem;
  font-style: normal;
  font-weight: 600;
  line-height: 0.2rem;
}

.pwd_hint.error {
  color: #ff4c62;
}
</style>

<style>
.set_payment_code_popup .input_area::placeholder {
  color: #aaa;
}
</style>



// WEBPACK FOOTER //
// src/components/PaymentCode/PaymentCodeSetPopup.vue